'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getArray = function getArray(length) {
  return new Array(length).join('0').split('');
};

var HOURS = exports.HOURS = getArray(24 + 1);
var TWELVE_HOURS = exports.TWELVE_HOURS = getArray(12 + 1);
var MINUTES = exports.MINUTES = getArray(60 + 1);

var PICKER_RADIUS = exports.PICKER_RADIUS = 130;
var MAX_ABSOLUTE_POSITION = exports.MAX_ABSOLUTE_POSITION = 125;
var MIN_ABSOLUTE_POSITION = exports.MIN_ABSOLUTE_POSITION = 90;
var POINTER_RADIUS = exports.POINTER_RADIUS = 15;

var TIMES_12_MODE = exports.TIMES_12_MODE = ['12:00 AM', '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM', '3:00 AM', '3:30 AM', '4:00 AM', '4:30 AM', '5:00 AM', '5:30 AM', '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM'];

var TIMES_24_MODE = exports.TIMES_24_MODE = ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-times/lib/utils/const_value.js
// module id = 152
// module chunks = 0